'use client';

import { $React } from '@legendapp/state/react-web';
import { useTabState } from '@/components/tabs/TabProvider';
import { cn } from '@/lib/cn';

export interface TabProps {
    className?: string;
    name?: string;
    tabId: string;
    label: string;
    defaultChecked?: boolean;
}

export function Tab({ className, label, tabId, ...props }: TabProps) {
    const tabState$ = useTabState();
    const tabElId = `tab-${tabId}`;
    const panelId = `tabpanel-${tabId}`;
    return (
        <$React.label
            $className={() =>
                cn(
                    'tab font-semibold z-1 flex transition text-white rounded-full opacity-100 whitespace-nowrap has-checked:text-primary',
                    'not-has-checked:hover:bg-accent not-has-checked:hover:text-base-content',
                    {
                        'has-checked:bg-white': !tabState$.indicator.enabled(),
                    }
                )
            }
            $aria-current={() => tabState$.activeTabId.get() === tabElId}
            $aria-selected={() => tabState$.activeTabId.get() === tabElId}
            aria-controls={panelId}
            role="tab"
        >
            {label}
            <$React.input {...props} id={tabElId} type="radio" />
        </$React.label>
    );
}
